$(document).ready(function(){

	const masonrySettings = {
	  itemSelector: '.grid-item',
		columnWidth: '.grid-sizer',
		gutter: '.gutter-sizer',
		percentPosition: true,
	};

	// -- init masonry --
	var $grid = $('.grid-masonry').masonry(masonrySettings);

	// -- layout masonry after each image loads --
	$grid.imagesLoaded().progress( function() {
	  $grid.masonry('layout');
	});

	setTimeout(function(){
		$grid.masonry('layout');
	},3000);
	setTimeout(function(){
		$grid.masonry('layout');
	},6000);

});